import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ExecuteOrderStatus } from 'projects/fe-insights-v2/src/app/components/order-management/order-management-model';
import { Subject } from 'rxjs';
import { take, debounceTime } from 'rxjs/operators';
import swal from 'sweetalert2';
import { EncryptionService } from '../../service/encryption.service';
import { CustomerManageOrdersService } from '../../service/cutomer-manage-order.service';
import { HelperService } from '../../service/helper.service';
import { DeletePopupComponent } from '../../popups/delete-popup/delete-popup.component';

@Component({
  selector: 'app-manage-order-listing',
  templateUrl: './manage-order-listing.component.html',
  styleUrls: ['./manage-order-listing.component.scss']
})
export class ManageOrderListingComponent implements OnInit {

  selection = new SelectionModel<any>(true, []);
  sidebarMenuName: string;
  executeOrderStatus = ExecuteOrderStatus
  private subject: Subject<string> = new Subject();
  page: any = 1;
  itemsPerPage: any = '10';
  totalItems: any = 0;
  totalCounttabs: any = 0;
  limit: any = 10;
  search: any = '';
  sortBy: any = '';
  sortKey = '';
  sortClass: any = 'down';
  noRecordFound = false;
  public requestPara = { search: '', page: 1, limit: 10, sortBy: '', sortKey: '', status: [1] };
  @ViewChild('searchBox') myInputVariable: ElementRef;
  @ViewChild('table') table: MatTable<any>;
  executeOrderData: any = new MatTableDataSource([]);
  executeOrderIds = [];
  companyId: any;
  executeOrderRolePermission: any;
  notStarted = 0;
  completed = 0;
  expiredCount = 0;
  refuseCount = 0;
  inProgress = 0;
  reviewOrder = 0;
  rejected = 0; 
  isNotClickedTab = false;
  selectedTab: any;
  saveTabInfo: any = '';
  orderTabbing = [];
  statusLabel: string;
  sliderChecked: boolean;
  selectedIndex: number = 0;
  selectedLogIndex: any;
  expiredTrue: string;
  currentTab: any;
  loggedUser: any;
  constructor(
    public dialog: MatDialog,
    private helper: HelperService,
    public translate: TranslateService,
    private router: Router,
    private apiService: CustomerManageOrdersService,
    private encryptionService: EncryptionService,
    private route: ActivatedRoute,

  ) {
    this._setSearchSubscription();
  }

  documentDisplayedColumns: string[] = ['proposalId', 'orderName', 'completionTime', 'status', 'details'];


  ngOnInit(): void {
    const loginUser = this.encryptionService.getDataFromLocalStorage('NPLoginId');
    this.loggedUser = JSON.parse(loginUser);

    this.setTabCount();
    this.sideMenuName();

    this.apiService.pagination.pipe(take(1)).subscribe(res => {
      this.pageChanged(res.page, res.limit.toString())
    })

  }

  onRefreshTable() {
    this.selection.clear();
    this.search = '';
    this.myInputVariable.nativeElement = '';
    this.pageChanged(1)
    document.body.classList.add('spin-animation');
    setTimeout(() => {
      document.body.classList.remove('spin-animation');
    }, 1000);
  }

  async tabChangedClick(statusType): Promise<void> {
    this.isNotClickedTab = true;
    this.requestPara.search = "";
    this.search = '';
  }

  async tabChanged(statusType): Promise<void> {
    this.selectedIndex = Number(statusType.tab.ariaLabel)
    const request = {
      search: '',
      page: 1,
      limit: this.itemsPerPage,
      sortBy: '',
      sortKey: '',

    };
    this.getExecuteOrderListing(request);
    this.pageChanged(1)
  }


  sideMenuName() {
    this.sidebarMenuName = this.translate.instant('ExecuteOrder.title'),
      this.helper.sideMenuListName.next(this.sidebarMenuName);
  }
  onKeyUp(searchTextValue: any): void {
    this.selection.clear();
    this.subject.next(searchTextValue);
  }

  resetSearch(): void {
    this.search = '';
    this.myInputVariable.nativeElement.value = '';
    this.page = 1;
    this.selection.clear();
    this.getExecuteOrderListing(this.requestPara = {
      page: 1,
      limit: this.limit,
      search: '',
      sortBy: this.sortBy,
      sortKey: this.sortKey,
      status: this.selectedTab

    });
  }

  private _setSearchSubscription(): void {
    this.subject.pipe(
      debounceTime(500)
    ).subscribe((searchValue: string) => {
      this.page = 1;
      this.selection.clear();
      this.getExecuteOrderListing(this.requestPara = {
        page: 1,
        limit: this.limit,
        search: this.search,
        sortBy: this.sortBy,
        sortKey: this.sortKey,
        status: this.selectedTab

      });
    });
  }

  changeItemsPerPage(event): void {
    // this.search = '';
    this.page = 1;
    this.itemsPerPage = event;
    this.selection.clear();
    this.getExecuteOrderListing(this.requestPara = {
      page: 1, limit: this.itemsPerPage, search: this.search,
      sortBy: this.sortBy,
      sortKey: this.sortKey,
      status: this.selectedTab,


    });
    this.limit = this.itemsPerPage;
  }


  viewExecuteOrderDetail(event): void {
    this.router.navigate(['view-details/' + event._id], { relativeTo: this.route });

  }

  changeSorting(sortKey, sortBy): void {
    this.sortKey = sortKey;
    this.sortBy = (sortBy === '-1') ? '1' : '-1';
    this.page = 1;
    this.selection.clear();
    this.getExecuteOrderListing(this.requestPara = {
      page: 1,
      limit: this.limit,
      search: this.search,
      sortBy: this.sortBy,
      sortKey: this.sortKey,
      status: this.selectedTab

    });
  }

  setTabCount() {
    this.orderTabbing = [
      { label: 'ExecuteOrder.All', indexNumber: ExecuteOrderStatus.All, count: this.totalCounttabs },
      { label: 'ExecuteOrder.NotStarted', indexNumber: ExecuteOrderStatus.NotStarted, count: this.notStarted },
      { label: 'ExecuteOrder.InProgress', indexNumber: ExecuteOrderStatus.InProgress, count: this.inProgress },
      { label: 'ExecuteOrder.Completed', indexNumber: ExecuteOrderStatus.Completed, count: this.completed },
      { label: 'ExecuteOrder.ReviewOrder', indexNumber: ExecuteOrderStatus.ReviewOrder, count: this.reviewOrder },
      { label: 'ExecuteOrder.Rejected', indexNumber: ExecuteOrderStatus.Reject, count: this.rejected }
    ];
  }


  resetCount() {
    this.notStarted = 0;
    this.inProgress = 0;
    this.completed = 0;
    this.reviewOrder = 0;
    this.rejected = 0; 
  }

  getTotalCount() {
    this.resetCount();
    this.apiService.getApprovedOrderCount('').subscribe((res: any) => {
      if (res.result) {
        const getdata = res.data;
        this.totalCounttabs = getdata.map(all => all.count).reduce((acc, all) => all + acc);
        for (let i = 0; i < getdata.length; i++) {
          if (getdata[i].status == ExecuteOrderStatus.NotStarted) {
            this.notStarted = getdata[i].count;
          }
          if (getdata[i].status == ExecuteOrderStatus.InProgress) {
            this.inProgress = getdata[i].count;
          }
          if (getdata[i].status == ExecuteOrderStatus.Completed) {
            this.completed = getdata[i].count;
          }
          if (getdata[i].status == ExecuteOrderStatus.ReviewOrder) {
            this.reviewOrder = getdata[i].count;
          }
          if (getdata[i].status == ExecuteOrderStatus.Reject) {
            this.rejected = getdata[i].count;
          }
        }
        this.setTabCount();
        this.helper.toggleLoaderVisibility(false);
      } else {
        this.helper.toggleLoaderVisibility(false);
        swal.fire(
          '',
          this.translate.instant(res.reason),
          'info'
        );
      }
    });
  }





  getExecuteOrderListing(req: any): any {
    this.requestPara["status"] = this.selectedIndex === 0 ? [] : [this.selectedIndex];
    this.apiService.getApprovedOrderList(this.requestPara).subscribe((res: any) => {
      this.helper.toggleLoaderVisibility(true);
      console.log(res.data)
      if (res.result) {
        if (res.data.data) {
          this.executeOrderData = res.data.data;
        } else {
          this.executeOrderData = [];
        }
        this.getTotalCount();
        this.totalItems = res.data.totalcount;
        console.log('this.totalItems', this.totalItems)
        this.noRecordFound = this.executeOrderData?.length > 0;
        this.helper.toggleLoaderVisibility(false);
      }
    }, (err: any) => {
      this.helper.toggleLoaderVisibility(false);
      swal.fire(
        '',
        this.translate.instant(err?.error?.message),
        'info'
      );
    });
  }

  pageChanged(page, limit?): void {
    this.selection.clear();
    this.itemsPerPage = limit ? limit : this.itemsPerPage

    this.apiService.pagination.next({
      page: page, limit: this.itemsPerPage, search: this.search,
      sortBy: this.sortBy,
      sortKey: this.sortKey,
      status: this.selectedTab
    })

    this.selectedLogIndex = null;
    this.getExecuteOrderListing(this.requestPara = {
      page, limit: this.itemsPerPage, search: this.search,
      sortBy: this.sortBy,
      sortKey: this.sortKey,
      status: this.selectedTab

    });
    this.page = page;
  }

     changeStatusApprove(req: any): any {
          const dialogRef = this.dialog.open(DeletePopupComponent, {
              data: {
                  heading: 'ORDERMANAGEMENT.MANAGEORDERS.ApproveOrder',
                  message: 'ORDERMANAGEMENT.MANAGEORDERS.ApproveOrderMessage',
                  statusNameType: 'active'
              }
          });
          dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                  const payload = {
                      status: ExecuteOrderStatus.Approved
                  };
                  this.apiService.updateOrderStatus(req._id, payload).subscribe((res: any) => {
                      if (res) {
                          this.helper.toggleLoaderVisibility(false);
                          this.onRefreshTable()
                          swal.fire(
                              '',
                              this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.ApproveStatusOrder'),
                              'success'
                          );
                      } else {
                          this.helper.toggleLoaderVisibility(false);
                          swal.fire(
                              '',
                              this.translate.instant(res.reason),
                              'error'
                          );
                      }
                  }, (err) => {
                      this.helper.toggleLoaderVisibility(false);
                      swal.fire(
                          '',
                          this.translate.instant(err?.error?.message),
                          'info'
                      );
                  });
              }
          });
      }
  
      changeStatusReject(req: any): any {
          const dialogRef = this.dialog.open(DeletePopupComponent, {
              data: {
                  heading: 'ORDERMANAGEMENT.MANAGEORDERS.RejectOrder',
                  message: 'ORDERMANAGEMENT.MANAGEORDERS.RejectOrderMessage',
                  statusNameType: 'active'
              }
          });
          dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                  const payload = {
                      status: ExecuteOrderStatus.Reject
                  };
                  this.apiService.updateOrderStatus(req._id, payload).subscribe((res: any) => {
                      if (res) {
                          this.helper.toggleLoaderVisibility(false);
                          this.onRefreshTable()
                          swal.fire(
                              '',
                              this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.ApproveStatusOrder'),
                              'success'
                          );
                      } else {
                          this.helper.toggleLoaderVisibility(false);
                          swal.fire(
                              '',
                              this.translate.instant(res.reason),
                              'error'
                          );
                      }
                  }, (err) => {
                      this.helper.toggleLoaderVisibility(false);
                      swal.fire(
                          '',
                          this.translate.instant(err?.error?.message),
                          'info'
                      );
                  });
              }
          });
      }


}
